import React, { useState, useEffect, FormEvent } from 'react';
import { FileInput, Alert, ProgressBar, Checkbox } from "@blueprintjs/core";
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { AxiosInstance } from 'axios';
import * as utils from "./utils";

import svgWait1 from './svg/wait1.svg'
import svgWait2 from './svg/wait2.gif'

import { SystemHeader } from './CommonUI';
 
interface ImportAnnouncementMainProps {
    gsb: AxiosInstance
    currentFile?: File
}


interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}


var GsbFlag: any;

function ImportAnnouncementMain({ gsb }: ImportAnnouncementMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [file1Label, setFile1Label] = useState("Choose file...")
    const [file2Label, setFile2Label] = useState("Choose file...")
    const [file3Label, setFile3Label] = useState("Choose file...")
    const [importok, setimportok] = useState(false)
    const [nUploaded, setnUploaded] = useState(0)
        
    const [file1Label_ori, setFile1Label_ori] = useState("")
    const [file2Label_ori, setFile2Label_ori] = useState("")
    const [file3Label_ori, setFile3Label_ori] = useState("")

    const [file1Label_ori_disp, setFile1Label_ori_disp] = useState("")
    const [file2Label_ori_disp, setFile2Label_ori_disp] = useState("")
    const [file3Label_ori_disp, setFile3Label_ori_disp] = useState("")

    const [file2Label_DiffDate, setfile2Label_DiffDate] = useState("")
    const [file3Label_DiffDate, setfile3Label_DiffDate] = useState("")

    const [taskList, setTaskList] = useState([] as TaskInfo[])
    const [showTasks, setShowTasks] = useState(false)

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("DEMO")
    const [DEF_ThemeNo, setDEF_ThemeNo] = useState("1")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [SAS_MKT, setSAS_MKT] = useState(false)

    useEffect(() => {
        (async () => {
            try {

                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key)
                if ( GsbFlag.isProduction == "Y" ) {
                    setDEF_ThemeNo(GsbFlag.DEF_THEME1);
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setDEF_ThemeNo(GsbFlag.DEF_THEME2);
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setSAS_MKT(GsbFlag.SAS_MKT)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                //console.log("SmMastMain onsubmit called", data)
                const res = await gsb.post('/Dividend',
                {   sb_data: {
                    },
                    cPgmId: "StockAnnouncement",
                    cAction: "ImportAnnouncementInfo",
                });

                console.log("ImportAnnouncementMain res.data.data: ", res.data.data, res.data.count) 


                if ( res.data.count > 0 ) {
                    if ( res.data.data[0].CA_CCASS_Rpt_hk_found ) {
                        //setFile1Label(res.data.data[0].cAnnouncement_hk)
                        setFile1Label_ori(res.data.data[0].cAnnouncement_hk_ori)
                        setFile1Label_ori_disp(res.data.data[0].cAnnouncement_hk)
                    }
                    if ( res.data.data[0].CA_CCASS_Rpt_MAMK_found ) {
                        //setFile2Label(res.data.data[0].cAnnouncement_MAMK)
                        setFile2Label_ori(res.data.data[0].cAnnouncement_MAMK_ori)
                        setFile2Label_ori_disp(res.data.data[0].cAnnouncement_MAMK)
                        setfile2Label_DiffDate(res.data.data[0].cAnnouncement_DiffDate_MAMK)
                    }
                    if ( res.data.data[0].CA_CCASS_Rpt_SZMK_found ) {
                        //setFile3Label(res.data.data[0].cAnnouncement_SZMK)
                        setFile3Label_ori(res.data.data[0].cAnnouncement_SZMK_ori)
                        setFile3Label_ori_disp(res.data.data[0].cAnnouncement_SZMK)
                        setfile3Label_DiffDate(res.data.data[0].cAnnouncement_DiffDate_SZMK)
                    }
                } else {

                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if (taskList.findIndex((t: TaskInfo) => t.status === 0) > -1) {
            //console.log("running task(s) found, refresh tasklist in 1s")
            setTimeout(async () => {
                try {
                    const res = await gsb.post('/tasklist', taskList.map((t) => t.id));
                    setTaskList(res.data.data)
                    
                } catch (error) {
                    utils.showError(error)
                }
            }, 3+1000)
        } else {
            //console.log("all task(s) completed.")
        }
    }, [taskList, gsb])

    const onUpload = (e: FormEvent) => {
        e.preventDefault();
        setnUploaded(0);

        if ( (file1Label == "Choose file..." || file1Label.length == 0) && file1Label_ori.length == 0 ) {
            //utils.showError("Please choose a file"); 
            setisShowAlert2(true)
            setShowAlert2Msg("Please choose a file")
            return
        } 
        //console.log("onUpload file1Label", file1Label)
        ;
        
        (async () => {
            try {
                const res = await gsb.post('/importupload2',
                    new FormData(e.target as HTMLFormElement), {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                
                setShowTasks(false)
                if ( res.data.uploaded > 0) {
                    setimportok(true)
                }
     
                setnUploaded(res.data.uploaded)
              
                if ( res.data.uploaded > 0) {
                    utils.showSuccess(`${res.data.uploaded} file(s) uploaded`)
                }

                onImportFiles()
                
            } catch (error) {
                utils.showError(error)
            }
        })()
    }
 
    const onImportFiles = () => {

        if ( (file1Label == "Choose file..." || file1Label.length == 0) && file1Label_ori.length == 0 ) {
            //utils.showError("Please choose a file"); 
            setisShowAlert2(true)
            setShowAlert2Msg("Please choose a file")
            return
        } 
        //console.log("onImportFiles file1Label", file1Label)
        ;
        if ( file1Label.length > 0 ) {
    
            (async () => {
                    try {
                      
                        const res = await gsb.post('/import',
                                {   sb_data: {
                                    impfile1Name: file1Label,
                                    impfile1Name_ori: file1Label_ori,
                                    impfile2Name: file2Label,
                                    impfile2Name_ori: file2Label_ori,
                                    impfile3Name: file3Label,
                                    impfile3Name_ori: file3Label_ori,
                                },
                                cPgmId: "ImportAnnouncement",
                            }); 
                        
                        if (res.data.ok ){
                            setTaskList(res.data.data)
                            setShowTasks(true)

                            setimportok(false)

                        } else {
                            if (! res.data.ok) {
                                //utils.showError(res.data.data);
                                setisShowAlert2(true)
                                setShowAlert2Msg(res.data.data)
                                return
                            }

                        }
                       
                        
                    } catch (error) {
                        utils.showError(error)
                    }
                })()
        }else {

            utils.showError("Please choose a file"); 

        }
    }
    const [selectedFile, setSelectedFile] = React.useState<File | string>('fileurl');
   
 
    //const fileChangedHandler = (e : React.ChangeEvent<HTMLInputElement>) => {nUploaded(0));
 
    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    
    return (
        <>
            <div className="Spacing-V-Menu"></div>
            <div className="Row">
                <FormGroup className="Col-1-12"  >
                    {CoHead}
                </FormGroup>
            </div>            
            <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
            
                <div className="Spacing-V-8"></div>
                <p><H3>Import CCNAN05 Corporate Announcement Master Data File </H3></p>
                <form className="Import" onSubmit={onUpload}>
                    <div className="Spacing-V-8"></div>
                    <div className="Row">
                        <FormGroup className="Col-1-4" label="CCNAN05 Corporate Announcement Data File , HKMK" labelFor="inputFile1">
                            <FileInput className="Col-1-4" inputProps={{ name: "file1" }} text={file1Label} onInputChange={utils.handleStringChange((s) => setFile1Label(utils.fileBase(s)))} />
                            <div>{file1Label_ori_disp}</div>
                        </FormGroup>
                        {SAS_MKT && <FormGroup className="Col-5-4" label="CCNAN05 Corporate Announcement Data File , MAMK" labelFor="inputFile2">
                            <FileInput className="Col-5-4" inputProps={{ name: "file2" }} text={file2Label} onInputChange={utils.handleStringChange((s) => setFile2Label(utils.fileBase(s)))} />
                            <div>{file2Label_ori_disp}</div>
                            <div style={{color:DEF_ThemeNo=="5 "?"Green":"red"}}>{file2Label_DiffDate}</div>
                        </FormGroup> }
                        {SAS_MKT && <FormGroup className="Col-9-4" label="CCNAN05 Corporate Announcement Data File , SZMK" labelFor="inputFile3">
                            <FileInput className="Col-9-4" inputProps={{ name: "file3" }} text={file3Label} onInputChange={utils.handleStringChange((s) => setFile3Label(utils.fileBase(s)))} />
                            <div>{file3Label_ori_disp}</div>
                            <div style={{color:DEF_ThemeNo=="5 "?"Green":"red"}}>{file3Label_DiffDate}</div>
                        </FormGroup> }
                    </div>
                    <div className="Spacing-V-8"></div>
                    <div className="Spacing-V-8"></div>
                    <div className="Row">
                        {/* <Button className="Col-1-1" type="submit" icon={IconNames.UPLOAD}>Upload</Button>               
                        <Button disabled= {! importok} className="Col-2-1" icon={IconNames.IMPORT} onClick={onImportFiles}>Process</Button> */}
                        <Button className="Col-1-2" type="submit" icon={IconNames.UPLOAD}>Upload & Process</Button>   
                    </div>
                </form>

                <div className="Spacing-V-8"></div>
            
                <div className="Spacing-V-16"></div>
                <Collapse isOpen={showTasks}>
                    <p>Import Files</p>
                    <HTMLTable striped interactive condensed>
                        <thead>
                            <th className="TCol-Ref">File Name</th>
                            <th className="TCol-description">description</th>
                            <th className="TCol-Progress">Progress</th>
                            <th className="TCol-Message">Message</th>
                            <th className="TCol-Log">Log</th>
                        </thead>
                        <tbody>
                            {taskList.map((t, i) =>
                                <tr key={i}>
                                    <td className="TCol-Ref">{t.ref}</td>
                                    <td className="TCol-Ref">{t.description}</td>                                
                                    <td className="TCol-Progress"><ProgressBar stripes={false} animate={false} value={t.progressValue / t.progressMax} /></td>
                                    <td className="TCol-Message">{t.message}</td>
                                    <td className="TCol-Log">{t.logFile && <a key={i} target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${t.logFile}&inline`}>View</a>}</td>
                                </tr>
                            )}
                        </tbody>
                    </HTMLTable>
                    <div className="Spacing-V-16"></div>
                </Collapse>
                <br></br>
                <p>Notes</p>
                <div>
                    <div>CORPORATE ANNOUNCEMENT MASTER DATA FILE - CCNAN05</div>
                    <div>Support following:-</div>
                    <div>Market Code: HKMK, MAMK, SZMK</div>
                    <div>Announcement record, Benefit Entitlement 101001</div>
                    <div>Entitlement Type: CASH DIVIDEND, RIGHTS ISSUE, BONUS ISSUE</div>
                    <p></p>
                    <div>CCASS Folder: CCASS_HKMK\yyyymmdd, CCASS_MAMK\yyyymmdd, CCASS_SZMK\yyyymmdd</div>
                </div>

                <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>
            </Card>
        </>
    )
}

export default ImportAnnouncementMain